/**
 * DEPRECATED: This file now delegates to sessionManager for all operations.
 * This consolidation prevents duplicate session IDs caused by conflicting
 * storage formats (encrypted vs plain JSON) on the same localStorage key.
 * 
 * DO NOT use SecureStorage for 'chatbot_session' - sessionManager owns that key.
 */

import { sessionManager } from './sessionManager';

export interface SessionMessage {
  id: string;
  content: string;
  sender: 'user' | 'assistant';
  timestamp: string;
}

export interface SessionContact {
  Datestamp: string;
  Form_Type: 'Contact' | 'Offers' | 'FinanceV1' | 'Service' | 'Appointment' | 'Chat';
  Form_Content: { [key: string]: any };
}

export interface ChatSession {
  sessionId: string;
  messages: SessionMessage[];
  createdAt: string;
  lastUpdated: string;
  Contact?: SessionContact;
}

/**
 * Initialize or get existing session - delegates to sessionManager
 * Returns a Promise for backward compatibility but resolves synchronously
 */
export const initializeSession = async (): Promise<ChatSession> => {
  const session = sessionManager.initializeSession();
  // Map to the simpler ChatSession interface expected by callers
  return {
    sessionId: session.sessionId,
    messages: session.messages,
    createdAt: session.createdAt,
    lastUpdated: session.lastUpdated,
    Contact: session.Contact
  };
};

/**
 * Log a message to the session - delegates to sessionManager
 */
export const logMessageToSession = async (content: string, sender: 'user' | 'assistant'): Promise<void> => {
  await sessionManager.logMessage(content, sender);
};

/**
 * Log contact information to the session - delegates to sessionManager
 */
export const logContactToSession = async (
  formType: 'Contact' | 'Offers' | 'FinanceV1' | 'Service' | 'Appointment' | 'Chat',
  formContent: { [key: string]: any }
): Promise<void> => {
  sessionManager.logContact(formType, formContent);
};

/**
 * Get current session - delegates to sessionManager
 * Returns a Promise for backward compatibility
 */
export const getCurrentSession = async (): Promise<ChatSession | null> => {
  const session = sessionManager.getCurrentSession();
  if (!session) return null;
  
  return {
    sessionId: session.sessionId,
    messages: session.messages,
    createdAt: session.createdAt,
    lastUpdated: session.lastUpdated,
    Contact: session.Contact
  };
};

/**
 * Clear current session - delegates to sessionManager
 */
export const clearSession = (): void => {
  sessionManager.clearSession();
};
